import { BuslineQueryData } from '@area-restrita/api-client/model/buslineQueryData';

export type ChecklistDisplay =
  | { type: 'configured'; label: string }
  | { type: 'default'; label: 'PADRÃO'; checklistName: string }
  | { type: 'unavailable'; label: 'N/A' };

export function getChecklistDisplay({
  checklist,
  defaultChecklist,
}: Pick<BuslineQueryData, 'checklist' | 'defaultChecklist'>): ChecklistDisplay {
  if (checklist) {
    return { type: 'configured', label: checklist.name };
  }

  if (defaultChecklist) {
    return {
      type: 'default',
      label: 'PADRÃO',
      checklistName: defaultChecklist.name,
    };
  }

  return { type: 'unavailable', label: 'N/A' };
}
